'use strict';

import { isDesktopLarge } from '../helpers/responsiveViewport';
import scrollTo from '../helpers/scrollTo';

const onMustacheLoaded = require('./mustacheLoad');
const getMustacheFiles = require('./loadMustachesFiles');
const checkEmptyModuleSection = require('./checkEmptyModules');
const reviewScore = require('./reviewScore');
const initGoogleCharts = require('./googleCharts');
const calculTopBars = require('../review/dashboard/dashboardProgressStatus');
const scrollToElement = require('../helpers/scrollToElement');
const getParameterByName = require('../helpers/getParameterByName');
const gotoGet = getParameterByName('goto');
const renderCharts = require('../charts/chartsRender');
const competizeAll = require('../review/competitors/competizeAll');
const pdfPopover = require('../pdf/pdfPopover');
const $body = $('body');
const $reviewNavigation = $('.review-navigation');

require('../modals/createAdvancedReview');

window.isInsideReview = $('#dashboard-content').hasClass('inside-page');
window.isAdvancedReview = $body.hasClass('review-advanced');
window.currentWebsite = $('#dashboard-site > h1 > a').data('url');

initGoogleCharts();
// Initialize scrollSpy on reviews (TableOfContent)
$reviewNavigation.find('a').click(function (e) {
  e.preventDefault();
  window.location.hash = $(this).attr('href');
  scrollTo($($(this).attr('href')), 0);
});

$body.scrollspy({
  target: '.review-navigation',
  offset: 81
});

function listenForScrollEvents () {
  window.addEventListener('message', function (e) {
    if (e.data && e.data.indexOf('com.woorank.parent_scroll') === 0) {
      const defaultMargin = (isDesktopLarge) ? 0 : 60;
      const menuTop = defaultMargin + Math.max(0, parseInt(e.data.split('_').pop(), 10));

      $('.review-navigation').css('top', menuTop + 'px');
    }
  });
}

function postMessage (message) {
  if (window.opener || window.top) {
    (window.opener || window.top).postMessage(message, '*');
  }
}

function postHeight () {
  return setTimeout(() => {
    const lastModule = $('.module').last();
    if (!lastModule || !lastModule.position()) {
      return;
    }
    const height = lastModule.position().top + lastModule.height();
    postMessage('com.woorank.height_' + height);
  }, 100);
}

function targetBlankLinks () {
  $('a').attr('target', '_blank');
}

postHeight();
window.addEventListener('crit-html-changed', postHeight, false);
$('.module').on('click', '.show-links a', postHeight);

if (window.wooGlobal.allLinksTargetBlank === true) {
  targetBlankLinks();
  window.addEventListener('crit-html-changed', targetBlankLinks, false);
}

if (!window.isMobile) {
  const initFlyingMenuInIframe = function (e) {
    window.removeEventListener('message', initFlyingMenuInIframe);
    // Handle the sidebar links
    $('.review-navigation')
      .css('transition', 'top 0.25s ease-out') // We want the menu to fly smoothly when scrolled
      .find('.sidenav-item')
      .off('click')
      .on('click', function (event) {
        event.preventDefault();

        const $element = $(this.getAttribute('href'));
        postMessage('com.woorank.scrollto_' + $element.offset().top);
      });

    $('.criterium').on('click', (e) => { postHeight(); }); // Update on advice click

    listenForScrollEvents();
  };

  window.addEventListener('message', function (e) {
    if (typeof e.data === 'string' && e.data.indexOf('com.woorank.init_frame') === 0) {
      initFlyingMenuInIframe();
    }
  });
}

if (!window.isInsideReview) {
  reviewScore.init();
}

require('./openCriterium');
require('./openExpandableBlock');
require('./showMoreTask');
require('./dashboard/dashboard');
require('./marketing-tasks/marketingTasks')();
require('./reviewRegeneration');

getMustacheFiles().then(onMustacheLoaded);

checkEmptyModuleSection();

if (window.isMobile) {
  $('#report-content').show();
}

calculTopBars();

$body.externalLinks();
$body.truncate();

postMessage('com.woorank.ready_to_receive');

// if ?goto= isset then go to this section
if (gotoGet && gotoGet !== '') {
  scrollToElement($('#' + gotoGet));
}

if (!window.isInside) {
  competizeAll(true);
}

renderCharts();

pdfPopover();
